import React, { ChangeEvent, useRef, useEffect } from "react";
import TextField, {
  TextFieldProps,
} from "@material-ui/core/TextField/TextField";
import mergeClasses from "classnames";
import useStyles from "./styles";

const handleWheel = (e: React.WheelEvent<HTMLDivElement>) => e.preventDefault();

const handleChangeInteger = (
  e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
) => {
  e.currentTarget.value = e.currentTarget.value.replace(/\D/g, "");
  return e;
};

const typeOnChangeDictionary: {
  [key: string]: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;
} = {
  integer: handleChangeInteger,
};

const DPTextField = ({
  className,
  ...props
}: TextFieldProps & { type: string | undefined }) => {
  const textFieldRef = useRef(null);
  useEffect(() => {
    const { current } = textFieldRef;
    if (props.type === "number" && current) {
      // @ts-ignore
      current.addEventListener("wheel", handleWheel);
      return () => {
        // @ts-ignore
        current.removeEventListener("wheel", handleWheel);
      };
    }
  }, [props.type]);

  const classes = useStyles();
  const mergedClasses = mergeClasses(className, classes.textfield);
  return (
    <TextField
      {...props}
      className={mergedClasses}
      onChange={
        props.type ? typeOnChangeDictionary[props.type] : props.onChange
      }
      ref={textFieldRef}
    />
  );
};

export default DPTextField;
